// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/** Ripples */\n/** Elements */\n/* Palette generated by Material Palette - materialpalette.com/blue/amber */\n/** Ripples */\n/** Elements */\n.flag[data-v-4211e0cf] {\n  border-radius: 8px 0 0 8px;\n  height: 20px;\n  max-width: 30px;\n  -o-object-fit: cover;\n     object-fit: cover;\n}", ""]);
// Exports
module.exports = exports;
